import { Box, Text } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const ToolRoomContainer = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  p: { sm: '500' },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    width: 98%;
    height: 98%;
    border-radius: 4px;
  `}
`;
export const ToolRoomBoxStyled = styled(Box).attrs({
  alignSelf: { sm: 'cernter' },
  justifyContent: { sm: 'center' },
  alignItems: { sm: 'center' },
})`
  width: 100%;
  height: 100vh;
`;

export const ToolRoomListAreaStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  mt: { sm: '400' },
  mb: { sm: '800' },
})`
  overflow-y: auto;
`;

export const SubtitleStyled = styled(Text).attrs({
  weight: '500',
  size: '300',
  color: 'neutral.800',
  family: 'openSansRegular',
})`
  margin-top: ${({ theme }) => theme.spacings[400]};
`;
export const LoaderContainer = styled(Box).attrs({ justifyContent: { sm: 'center' }, alignItems: { sm: 'center' } })`
  width: 100%;
  height: 100%;
`;
